import React from 'react';
import { FileCheck, Shield, CheckCircle2 } from 'lucide-react';
import { StatusBadge } from '@/components/common/StatusBadge';
import { useAuthContext } from '@/hooks/useAuthContext';

export const SettingsKycCard: React.FC = () => {
  const { orgStatus } = useAuthContext();

  return (
    <div className="bg-[#0E1015] border border-zinc-800 rounded-2xl p-6 space-y-6">
      <div className="flex items-center gap-3 pb-4 border-b border-zinc-800">
        <div className="w-8 h-8 rounded-lg bg-indigo-600/10 border border-indigo-500/20 flex items-center justify-center text-indigo-400">
          <FileCheck className="w-4 h-4" />
        </div>
        <div>
          <h2 className="text-sm font-semibold text-white">KYC Verification & Compliance</h2>
          <p className="text-xs text-zinc-400">
            Verify identity documents and business registry for automatic payout disbursements
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-zinc-950 border border-zinc-850 p-4 rounded-xl">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[11px] text-zinc-400 uppercase font-medium">National ID (NID)</span>
            <CheckCircle2 className="w-4 h-4 text-emerald-400" />
          </div>
          <p className="text-xs font-semibold text-white">Identity Verified</p>
          <p className="text-[11px] text-zinc-400 mt-1">Smart NID verified for commission payouts</p>
        </div>

        <div className="bg-zinc-950 border border-zinc-850 p-4 rounded-xl">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[11px] text-zinc-400 uppercase font-medium">Trade License / BIN</span>
            <CheckCircle2 className="w-4 h-4 text-emerald-400" />
          </div>
          <p className="text-xs font-semibold text-white">Business Registration</p>
          <p className="text-[11px] text-zinc-400 mt-1">Agency & Growth Partner verification</p>
        </div>

        <div className="bg-zinc-950 border border-zinc-850 p-4 rounded-xl">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[11px] text-zinc-400 uppercase font-medium">Disbursement Account</span>
            <CheckCircle2 className="w-4 h-4 text-emerald-400" />
          </div>
          <p className="text-xs font-semibold text-white">Payout Method Ready</p>
          <p className="text-[11px] text-zinc-400 mt-1">Enabled for direct bKash and BEFTN bank transfers</p>
        </div>
      </div>

      <div className="bg-zinc-950 border border-zinc-850 rounded-xl p-5">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-8 rounded-lg bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center text-emerald-400">
            <Shield className="w-4 h-4" />
          </div>
          <div>
            <h3 className="text-xs font-semibold text-white">Partner Account in Good Standing</h3>
            <p className="text-[11px] text-zinc-400">
              Your partner account is active and verified to receive monthly commission settlements.
            </p>
          </div>
        </div>

        <div className="p-3.5 bg-zinc-900/60 border border-zinc-800 rounded-xl text-xs text-zinc-400 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400" />
            <span>All verification documents are current and approved.</span>
          </div>
          <StatusBadge status={orgStatus} size="xs" />
        </div>
      </div>
    </div>
  );
};
